module.exports = __webpack_public_path__ + "static/media/complexPic14.56249602.png";